var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconService06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_10379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9876 29.351H14.7157L9.08203 19.594L14.7157 9.83703H25.9876L31.6213 19.594L25.9876 29.351ZM16.3115 26.5922H24.3964L28.4389 19.594L24.3964 12.5958H16.3115L12.2691 19.594L16.3115 26.5922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9876 46.1614H14.7157L9.08203 36.3998L14.7157 26.6428H25.9876L31.6213 36.3998L25.9876 46.1568V46.1614ZM16.3115 43.4026H24.3964L28.4389 36.4044L24.3964 29.4062H16.3115L12.2691 36.4044L16.3115 43.4026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5252 37.7562H28.6738V34.9974H38.934L42.9765 27.9992L38.934 21.001H28.6738V18.2422H40.5252L46.1635 27.9992L40.5252 37.7562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8583 31.9075C32.7014 31.9075 30.9492 30.1557 30.9492 27.9992C30.9492 25.8427 32.7014 24.0909 34.8583 24.0909C37.0152 24.0909 38.7674 25.8427 38.7674 27.9992C38.7674 30.1557 37.0152 31.9075 34.8583 31.9075ZM34.8583 26.8497C34.2236 26.8497 33.7086 27.3647 33.7086 27.9992C33.7086 28.6337 34.2236 29.1487 34.8583 29.1487C35.4929 29.1487 36.008 28.6337 36.008 27.9992C36.008 27.3647 35.4929 26.8497 34.8583 26.8497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_10379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.0811,
    height: 36.3243,
    fill: "white",
    transform: "translate(9.08203 9.83703)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService06);
export default __webpack_public_path__ + "static/media/icon_service06.d699b065fb609e0982bec5dbc8e7aa0a.svg";
export { ForwardRef as ReactComponent };